import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ModuleState } from '../reducers/module.reducer';
import { MODULE_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<ModuleState>(MODULE_FEATURE_KEY);

export const selectLoaded = createSelector(selectState, (state: ModuleState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: ModuleState) => state.loading);
export const selectSaving = createSelector(selectState, (state: ModuleState) => state.saving);
export const selectSaved = createSelector(selectState, (state: ModuleState) => state.saved);
export const selectError = createSelector(selectState, (state: ModuleState) => state.error);
export const selectModule = createSelector(selectState, (state: ModuleState) => state.module);
